import React, { useState, useContext } from 'react'
import noteContext from "../context/notes/noteContext"

const AddNote = (props) => {
    const context = useContext(noteContext)
    const { addNote } = context;

    const [note, setNote] = useState(
        {
            title: "",
            description: "",
            tag: ""
        }
    )

    const handleClick = (e) => {
        e.preventDefault();
        addNote(note.title, note.description, note.tag)
        setNote({
            title: "",
            description: "",
            tag: ""
        })
        props.showAlert("Added successfully", "success")

    }
    const onChange = (event) => {
        setNote(
            {
                ...note,
                [event.target.name]: event.target.value
            }
        )
    }
    return (
        <div className="container my-3">
            <h2>Add a Note</h2>
            <form>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input type="text" className="form-control" id="title" name="title" value={note.title} aria-describedby="" onChange={onChange} minLength={3} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="description" className="form-label">Description</label>
                    <textarea type="text" className="form-control" id="description" name="description" value={note.description} onChange={onChange} minLength={5} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="tag" className="form-label">Tag</label>
                    <input type="text" className="form-control" id="tag" name="tag" value={note.tag} aria-describedby="" onChange={onChange} />
                </div>
                <button type="submit" className="btn btn-dark" onClick={handleClick} disabled={note.title.length < 3 || note.description.length < 5} > Add Note </button>
            </form>
        </div>
    )
}

export default AddNote